import { Routes, Route, Navigate } from 'react-router-dom';
import { platformRoutes } from 'platform/routes';
import { payrollRoutes } from 'services/payroll/routes';
import { contractRoutes } from 'services/contract/routes';
import { systemRegisterRoutes } from 'services/system-register/routes';

/** Composes platform shell routes + per-service business routes */
const AppRoutes = () => {
  return (
    <Routes>
      {platformRoutes}
      {payrollRoutes}
      {contractRoutes}
      {systemRegisterRoutes}
      <Route path="*" element={<Navigate to="/notFound" />} />
    </Routes>
  );
};

export default AppRoutes;
